import React from "react";

export default function LifecycleHeader() {

  return (
    <div className="page-header">

      <h2>Material Lifecycle Report</h2>

      <p>
        Trace complete lifecycle of material from indent to production consumption
      </p>

    </div>
  );

}